module.exports = __webpack_public_path__ + "static/4-158898b4a74bd732819b86f2b07d5c58.jpg";